import { render, staticRenderFns } from "./leave-list.vue?vue&type=template&id=6c211126&scoped=true"
import script from "./leave-list.vue?vue&type=script&lang=js"
export * from "./leave-list.vue?vue&type=script&lang=js"
import style0 from "./leave-list.vue?vue&type=style&index=0&id=6c211126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c211126",
  null
  
)

export default component.exports